import { Checkbox } from "../../Checkbox";
import { Skeleton } from "../../Skeleton";
import type { CellComponentProps } from "../DataTable.types";
import { getCellContainerClasses, resolveValue } from "./cellUtils";

export interface SelectCellProps<T = any> extends CellComponentProps<T> {
  isSelected?: boolean;
  onSelect?: (row: T, checked: boolean) => void;
  isDisabled?: boolean | ((row: T) => boolean);
  align?: "left" | "center" | "right";
}

/**
 * SelectCell
 *
 * DataTable cell component for row selection.
 * Renders a checkbox that allows users to select individual rows in the table.
 */
export function SelectCell<T = any>({
  row,
  context,
  isSelected = false,
  onSelect,
  isDisabled = false,
  align = "center",
}: SelectCellProps<T>) {
  const { isLoading } = context;

  if (isLoading) {
    return (
      <div className={getCellContainerClasses(align)}>
        <Skeleton className="h-4 w-4 rounded" />
      </div>
    );
  }

  const disabled = resolveValue(isDisabled, row);
  const className = getCellContainerClasses(align);

  return (
    <div className={className}>
      <Checkbox
        isSelected={isSelected}
        onChange={(checked) => {
          onSelect?.(row, checked);
        }}
        isDisabled={disabled}
        aria-label={`Select row`}
      />
    </div>
  );
}
